import React from 'react';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Box, Text, Button, Icon, Heading } from 'roo-ui/components';
import { mediaQuery } from 'lib/styledSystem';
import { useDialog } from 'components/Dialog';

const changeSelection = () => window.history.back();

const UppercaseButton = styled(Button)`
  text-transform: uppercase;
  background-color: ${themeGet('colors.brand.primary')};
  padding: ${themeGet('space.2')} ${themeGet('space.5')};
  width: 100%;

  ${mediaQuery.minWidth.sm} {
    min-width: 188px;
    width: initial;
  }
`;

const AlignedHeading = styled(Heading.h3)`
  vertical-align: middle;
  line-height: 1.3;
`;

const InsufficientPoints = () => {
  const { Dialog } = useDialog({ initialiseOpen: true });
  return (
    <Dialog>
      <Box mb={4}>
        <Icon display="inline" mr={1} name="warning" color="ui.error" />
        <AlignedHeading display="inline">Sorry, you don&apos;t have enough Qantas Points to book.</AlignedHeading>
      </Box>
      <Text display="block" mb={6}>
        We could not continue your booking at this time. Please choose another room.
      </Text>
      <UppercaseButton onClick={changeSelection} aria-label="Change your room selection" data-testid="classic-cta-button">
        Change selection
      </UppercaseButton>
    </Dialog>
  );
};

export default InsufficientPoints;
